<div class="user-delegation-form">

    <div class="modal-header">
        <h2 class="modal-title" translate="Delegations.FormTitle" [translateParams]="{ name: user.firstName + ' ' + user.lastName }"></h2>
        <button type="button" class="modal-button-close far fa-times" (click)="activeModal.close()"></button>
    </div>

    <div [formGroup]="form" class="modal-body" [class.block-loader]="loader.isLoading">
        <loader-spinner [model]="loader"/>

        @if (delegations$ | async; as delegations) {
            @if (!delegations.userRoleDelegationIds.length && !delegations.superDebtorDelegationIds.length) {
                <ngb-alert type="warning" class="mb-4" [dismissible]="false">
                    {{ 'Delegations.NoDelegationsAtAll' | translate }}
                </ngb-alert>
            }
        }

        @if (users$ | async; as users) {
            @if (user.subsidiaryRole !== UserRole.Observer) {
                <h3 translate="Delegations.RolesDelegation">
                    <i class="far fa-info-circle" ngbTooltip="{{ 'Delegations.RolesDelegationTooltip' | translate }}"></i>
                </h3>
                <div class="user-delegation-form-roles col-12 mb-4">
                    <div class="row">
                        <div class="col-6" translate="Delegations.ToUsers"></div>
                        <div class="col-6">
                            <select type="text" autocomplete="off" class="form-control form-control-alt" formControlName="userRoleDelegationIds">
                                @for (user of users; track user) {
                                    <option [value]="user.value">{{ user.label }}</option>
                                }
                            </select>
                            <form-control-feedback [field]="userRoleField"/>
                        </div>
                    </div>
                </div>
            }

            <h3 translate="Delegations.ClientsDelegation">
                <i class="far fa-info-circle" ngbTooltip="{{ 'Delegations.ClientsDelegationTooltip' | translate }}"></i>
            </h3>
            <div class="user-delegation-form-clients col-12 mb-4">
                <div class="row">
                    <div class="col-6" translate="Delegations.ToUsers"></div>
                    <div class="col-6">
                        <select type="text" autocomplete="off" class="form-control form-control-alt" formControlName="superDebtorDelegationIds">
                            @for (user of users; track user) {
                                <option [value]="user.value">{{ user.label }}</option>
                            }
                        </select>
                        <form-control-feedback [field]="superDebtorField"/>
                    </div>
                </div>
            </div>
        }

        <h3 translate="Delegations.ForPeriod">
            <i class="far fa-info-circle" ngbTooltip="{{ 'Delegations.ForPeriodTooltip' | translate }}"></i>
        </h3>
        <div class="user-delegation-form-clients col-12 mb-4">
            <div class="row">
                <div class="col-6" translate="Delegations.PeriodUntil"></div>
                <div class="col-6">
                    <form-datepicker
                        formControlName="end"
                        [control]="endField"
                        [minDate]="today"
                        [class.is-invalid]="endField.dirty && endField.invalid"
                        placement="top"
						[isDisabled]="canDateBeSelected"
                    />
                    <form-control-feedback [field]="endField"/>
                </div>
            </div>
        </div>
    </div>

	<div class="modal-footer d-flex flex-row-reverse">
        <button type="button" class="btn btn-primary"
                (click)="onSubmit()"
                [disabled]="!canSubmit()"
                translate="Actions.SaveAlt" data-cy="SaveAlt"></button>

        <button type="button" class="btn btn-default"
                (click)="activeModal.close()"
                translate="Actions.Cancel" data-cy="Cancel"></button>
    </div>
</div>
